import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

export default {
    path: '/ubo-funnel/:id',
    component: () => import('@/components/Funnel/UboFunnel/views/UboFunnel.vue'),
    name: 'ubo-funnel',
    meta: {
        private: true,
        layout: Layout.HeaderOnly,
    },
    children: [
        {
            path: 'organizations',
            name: 'ubo-organizations',
            component: () => import('@/components/Funnel/UboFunnel/components/UboOrganizations.vue'),
        },
        {
            path: 'payment',
            name: 'ubo-payment',
            component: () => import('@/components/Funnel/UboFunnel/components/UboPayment.vue'),
        },
        {
            path: 'documents',
            name: 'ubo-documents',
            component: () => import('@/components/Funnel/UboFunnel/components/UboDocuments.vue'),
        },
        {
            path: 'edit',
            name: 'ubo-edit',
            component: () => import('@/components/Funnel/UboFunnel/components/UboEditOrganization.vue'),
        },
    ],
} as RouteRecordRaw;
